import ar from 'element-ui/lib/locale/lang/ar';

// 阿拉伯语(沙特)
export default {
  ...ar,
  layout: {
    title: 'تسجيل الدخول باستخدام مُعرِّف Uniportal',
    tip: 'سيتم تسجيل رقم الجوال غير المسجل تلقائيًا بعد تسجيل الدخول بنجاn',
    line: 'خيارات تسجيل الدخول الأخرى',
  },
  button: {
    submit: 'تسجيل الدخول/التسجيل',
    getCode: 'كود CAPTCHA',
    emailRegister: 'ثبت‌نام با ایمیل',
    w3Login: 'تسجيل الدخول إلى حساب W3',
    employeeLogin: 'تسجيل دخول الموظف',
    passwordLogin: 'تسجيل الدخول بكلمة مرور',
    reSend: 'إعادة الإرسال',
    problem: 'المساعدة عبر الإنترنت',
    privacyPolicy: 'سياسة الخصوصية',
  },
  placeholder: {
    phoneNumber: 'رقم الهاتف الجوال',
    verificationCode: 'کد تأييد پیامکی',
  },
  dialog: {
    imgCode: 'أدخل الأحرف الموجودة في الصورة.',
    userAgreements: {
      header: 'اتفاقية المستخدم وبيان الخصوصية',
      text1: 'يُرجى قراءة {privacy} و{agreement} والموافقة عليها.',
      text2:
        'سيتم إرسال المعلومات الشخصية إلى الشركات التابعة لهواوي في الخارج للمعالجة عند الوصول إلى تطبيقات هواوي في الخارج. لمزيد من التفاصيل، يرجى الرجوع إلى {privacy}',
    },
    crossBorder: {
      header: 'تلميحات التخويل',
      text: 'الخدمة المحلية التي تستخدمها ومكان تسجيل حسابك ليسا في نفس المنطقة.يتطلب الوصول إلى معلومات الحساب عبر الحدود إذنًا منك.',
    },
    multiAccounts: 'يُرجى تحديد حساب.',
    agreeButton: 'الموافقة والمتابعة',
    disagreeButton: 'لا أوافق',
    confirmButton: 'تأكيد',
    cancelButton: 'ألغي الأمر',
    knowMe: 'موافق',
  },
  toast: {
    hasSend: 'کد تأیید ارسال شد.',
    wait: 'لحظة واحدة، من فضلك',
  },
  tooltip: {
    Huawei: 'حساب هواوي',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'مطلوب إدخال رمز CAPTCHA',
    'IDC-03-0002': 'انتهت صلاحية رمز CAPTCHA',
    'IDC-00-0004': 'رمز CAPTCHA غير صحيح',

    // 表单输入为空
    'IDC-01-00024': 'مطلوب إدخال رمز البلد للتحقق من رقم جوالك.',
    phoneNumberEmpty: 'أدخل رقم الجوال.',
    'IDC-03-00033': 'أدخل كود التحقق الموجود في الرسالة النصية.',

    // 表单数据错误
    'IDC-02-00227': 'رقم الجوال الذي تم إدخاله لا يتطابق مع البلد/المنطقة المحددة',
    'IDC-02-00226': 'تم حظر رمز البلد',
    'IDC-02-00029': 'رمز التحقق غير صحيح أو منتهية الصلاحية',
    'IDC-02-0013': 'فشل تسجيل الدخول عبر الرسائل النصية القصيرة. رمز التحقق غير صحيح',
    'IDC-02-0020': 'تعذّر التحقق. رمز التحقق غير صحيح.',
    'IDC-02-00028': 'يجب أن يكون رقم الجوال من 6 إلى 30 رقمًا',
    'IDC-02-00012': 'رقم الجوال غير صحيح',

    // 错误操作锁定
    accountLock:
      'رقم الجوال أو رمز التحقق غير صحيح. لديك {number} محاولات متبقية. | رقم الجوال أو رمز التحقق غير صحيح. لديك محاولة واحدة متبقية. | رقم الجوال أو رمز التحقق غير صحيح. لديك محاولتان متبقيتان. | رقم الجوال أو رمز التحقق غير صحيح. لديك {number} محاولات متبقية. | رقم الجوال أو رمز التحقق غير صحيح. لديك {number} محاولة متبقية. | رقم الجوال أو رمز التحقق غير صحيح. لديك {number} محاولة متبقية.',
    accountLocked:
      'لقد أجريت العديد من المحاولات الفاشلة. يُرجى إعادة المحاولة بعد {number} ثوانٍ. | لقد أجريت العديد من المحاولات الفاشلة. يُرجى إعادة المحاولة بعد ثانية. | لقد أجريت العديد من المحاولات الفاشلة. يُرجى إعادة المحاولة بعد ثانيتين. | لقد أجريت العديد من المحاولات الفاشلة. يُرجى إعادة المحاولة بعد {number} ثوانٍ. | لقد أجريت العديد من المحاولات الفاشلة. يُرجى إعادة المحاولة بعد {number} ثانية. | لقد أجريت العديد من المحاولات الفاشلة. يُرجى إعادة المحاولة بعد {number} ثانية.',
    operationRisk:
      'تحتوي العملية الحالية على مخاطر أمنية. الرجاء إعادة المحاولة بعد {number} ثانية!',

    // 频繁操作
    'IDC-02-00038': 'يُرجى المحاولة مرة أخرى بعد 60 ثانية.',
    'IDC-02-00064':
      'لقد قمت بإرسال رمز التحقق من الرسائل النصية القصيرة بشكل متكرر، يرجى المحاولة مرة أخرى بعد 24 ساعة!',
    'IDC-02-00211': 'العملية الحالية تنطوي على مخاطر أمنية. يُرجى إعادة المحاولة لاحقًا!',
    'IDC-02-00212':
      'تم إرسال رمز التحقق من الرسائل النصية القصيرة بشكل متكرر إلى رقم هاتفك الجوال. حاول تغيير رقمك الجوال أو حاول مرة أخرى بعد 24 ساعة!',
    'IDC-02-00213':
      'لقد قمت بإرسال رمز التحقق من الرسائل النصية القصيرة بشكل متكرر، يرجى المحاولة مرة أخرى بعد 24 ساعة!',
    'IDC-02-00215':
      'تم إرسال رمز التحقق من الرسائل النصية القصيرة بشكل متكرر إلى رقم هاتفك الجوال.' +
      ' حاول تغيير رقم هاتفك الجوال أو اختر طريقة أخرى للتحقق أو حاول مرة أخرى بعد 24 ساعة!',
    'IDC-02-00228':
      'لقد قمت بإرسال رمز التحقق من الرسائل النصية القصيرة بشكل متكرر. يرجى المحاولة مرة أخرى بعد ساعة!',
    'IDC-02-00092': 'العملية الحالية متكررة جدًا، يُرجى إعادة المحاولة بعد 24 ساعة.',

    // 请求异常
    'IDC-10-00400': 'طلب العميل غير طبيعي ',
    'IDC-10-00500': 'خطأ داخلي في النظام ',
    'IDC-02-00264': 'طلبات الوصول غير المصرح بها ممنوعة',
    'IDC-02-00063': 'معلمة غير صالحة',
    'IDC-03-0007': 'تحتوي العملية الحالية على مخاطر أمنية ولا يمكن تسجيلها مؤقتًا.', // 机翻
    'IDC-03-00057': 'تنطوي العملية الحالية على مخاطر أمنية.',

    // 页面过期
    'IDC-00-00017': 'انتهت صلاحية الصفحة.',
  },

  // 注册协议、隐私声明对话框
  backButton: `إغلاق`,
  closeButton: `إغلاق`,

  // 滑块验证相关：
  resourceReqFailed: 'فشل طلب المورد. حدّث الصفحة وحاول مرة أخرى.',
  verifyFailedAndPlsRetry: 'فشل التحقق، يُرجى إعادة المحاولة',
  serviceErrAndPlsRetry: 'استثناء في الخدمة. يُرجى إعادة المحاولة.',
  learnMore: 'تعرّف على المزيد',
  cookieBannerText: 'يستخدم هذا الموقع وظائف ملفات تعريف الارتباط لتعطيك أفضل تجربة مستخدم ممكنة.',
};
